/**
 * @param {Function} callback - A function to be called when an observed element intersects with the viewport.
 * callback only trigger on intersecting elements.
 * @param {Object} [options={}] - Optional configuration options for the IntersectionObserver.
 * @returns {IntersectionObserver} The created IntersectionObserver instance.
 */
const intersectionObserver = (callback, options) => {
  // Check if IntersectionObserver is supported
  if ('IntersectionObserver' in window) {
    return new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback(entry, observer);
        }
      });
    }, options);
  }
  return null;
};

export default intersectionObserver;
